import React from "react";

import { NextPage } from "next";
import Head from "next/head";

import { MyDemandHqsParent } from "@views/MyDemandHqsParent";

const HomePage: NextPage = () => {
    return (
        <>
            <Head>
                <title>My DemandHqs | Resonance</title>
            </Head>
            <MyDemandHqsParent />
        </>
    );
};

export default HomePage;
